export const HUMAN = 'HUMAN';
export const BOT = 'BOT';
export const AI = 'AI';